import { render } from "./passCardAlert.html?vue&type=template&id=12dbea5e&scoped=true&ts=true&external"
import script from "./PassCardAlert.vue?vue&type=script&lang=ts"
export * from "./PassCardAlert.vue?vue&type=script&lang=ts"

import "./PassCardAlert.vue?vue&type=style&index=0&id=12dbea5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12dbea5e"]])

export default __exports__